import { createRoot } from "solid-js"
import { StateT as GeneratedStateT, StateType as GeneratedStateType } from "../../../../engine/bindings/typescript/tbs"
import { type Object3D } from "three"
import createEngineForUI from "../../../core/engine/createEngineForUI"
import type { EntityGraphNode } from "../../../core/engine/EntityGraphNode/EntityGraphNode.type"
import createTileGraphNodeCollectionMemo from "../../../core/engine/TileGraphNode/createTileGraphNodeCollectionMemo"
import { toGeneratedEntity } from "../../../core/engine/engineWasmCodec"
import type { Entity } from "../../../core/entity/index"
import { HALF_PI } from "../../../core/util/math/Math"
import { addGameObject3DEventListener } from "../../../event/GameObject3D/GameObject3DEvent"
import createTerrainMesh1V2Group from "./createTerrainMesh1V2Group"

export default function makeSingleTileTerrainMesh1Object3D(
  entNode: EntityGraphNode<Entity>,
  // pto: PlayerThreeObject,
  callback: (newGroup: Object3D) => void
): void {
  const engine = createEngineForUI()
  void engine.bootstrapWasmState(new GeneratedStateT(
    1,
    null,
    null,
    null,
    GeneratedStateType.Map,
    1,
    1,
    [toGeneratedEntity({
      ...entNode.raw(),
      x: 0,
      y: 0,
    })]
  ))

  createRoot((dispose) => {
    const getTpNodeList = createTileGraphNodeCollectionMemo(engine)
    const group = createTerrainMesh1V2Group(engine, getTpNodeList())
    // group.position.z -= VERTICES_PER_TILE
    group.rotateX(HALF_PI)

    addGameObject3DEventListener(group, "dispose", dispose)

    callback(group)

  })
}
